module.exports = __webpack_public_path__ + "img/LaBase-Sorrento-Burger-600px.293e174a.jpg";